import { render, staticRenderFns } from "./org-edit.vue?vue&type=template&id=17b127c2&scoped=true&"
import script from "./org-edit.vue?vue&type=script&lang=js&"
export * from "./org-edit.vue?vue&type=script&lang=js&"
import style0 from "./org-edit.vue?vue&type=style&index=0&id=17b127c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b127c2",
  null
  
)

export default component.exports